import * as Utils from '@services/utils'
import api from '@services/api'
import i18n from '@localization/i18n'

export const defaultDance = {
    status: null,
    name: '',
    choreographer: null,
    co_choreographers: [],
    co_choreographers_string: '',
    style: '',
    video_url: '',
    performer: '',
    song: {
        translated_version_id: '',
        akum_id: '',
        name: '',
        composer: '',
        lyricist: '',
        //translator: '',
        video_url: '',
        composers: [],
        lyricists: [],
        lyrics: '',
    },
    notes: '',
}

export const dateFormat = 'H:mm DD/MM/YYYY'
export const completionDateFormat = 'DD/MM/YYYY'
export const datePickerFormat = 'YYYY-MM-DD'
export const existingDanceCompletionDateFormat = 'YYYY'
export const requestDateFormat = 'H:mm:ss DD/MM/YYYY'

export const getCoChoreographersText = (coChoreographers) => {
    let fixedCo = []
    if (!Utils.isEmpty(coChoreographers)) {
        coChoreographers.map((c) => {
            if (c['label'] && !Utils.isEmptyStr(c['label'])) {
                fixedCo.push(c)
            } else if (c['first_name'] && c['last_name']) {
                fixedCo.push({
                    label: c['first_name'] + ' ' + c['last_name'],
                    value: c['id'],
                })
            }
        })
    }
    return fixedCo
}

export const getDanceById = (id, callBack) => {
    api.getDanceById(id).subscribe(
        (res) => {
            // console.log('getDanceById from api res', res)
            callBack(res.data.res)
        },
        (error) => console.log('getDancesTypes from api error', error)
    )
}

export const saveDance = (dance, callback, onError) => {
    const danceName = dance?.name?.trim()
    const trimmedDance = { ...dance, name: danceName }
    api.saveDance(trimmedDance).subscribe(
        (res) => {
            callback(res)
        },

        (error) => {
            if (onError) {
                onError(error.data)
            }
        }
    )
}

export const requiredFieldEmptyText = i18n.t('edit_dance.input_missing')
// 'אחד (או יותר) משדות החובה ריקים'
